import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";
import { BUSINESS, TOWNS } from "../lib/site";

const SITE_URL = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");
const OG_IMAGE =
    "https://images.unsplash.com/photo-1476589143317-647df3b59c32?q=80&w=1200&auto=format&fit=crop";

const localBusinessJsonLd = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "@id": `${SITE_URL}/#business`,
    name: BUSINESS.name,
    url: SITE_URL,
    telephone: "+1-573-300-8625",
    email: BUSINESS.email,
    image: OG_IMAGE,
    priceRange: "$150 - $535+",
    description:
        "Stump grinding and full cleanup in Poplar Bluff, MO and a 30-mile radius. Same-week guarantee, upfront pricing by stump size.",
    address: {
        "@type": "PostalAddress",
        addressLocality: "Poplar Bluff",
        addressRegion: "MO",
        addressCountry: "US",
    },
    geo: { "@type": "GeoCoordinates", latitude: 36.757, longitude: -90.394 },
    areaServed: [
        { "@type": "GeoCircle", geoMidpoint: { "@type": "GeoCoordinates", latitude: 36.757, longitude: -90.394 }, geoRadius: "48280" },
        ...TOWNS.map((t) => ({ "@type": "City", name: `${t}, MO` })),
    ],
    openingHoursSpecification: {
        "@type": "OpeningHoursSpecification",
        dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
        opens: "07:00",
        closes: "18:00",
    },
    paymentAccepted: "Cash, Credit Card",
    hasOfferCatalog: {
        "@type": "OfferCatalog",
        name: "Stump grinding services",
        itemListElement: [
            { "@type": "Offer", itemOffered: { "@type": "Service", name: "Stump grinding (ground below grade, chips raked back)" } },
            { "@type": "Offer", itemOffered: { "@type": "Service", name: "Debris haul-off, topsoil, seed and straw" } },
            { "@type": "Offer", itemOffered: { "@type": "Service", name: "Full lawn restoration after stump removal" } },
        ],
    },
};

export const Seo = ({ title, description, noindex = false, jsonLd }) => {
    const { pathname } = useLocation();
    const canonical = `${SITE_URL}${pathname === "/" ? "/" : pathname}`;
    const fullTitle = title ? `${title} | ${BUSINESS.name}` : `${BUSINESS.name} | Stump Grinding & Cleanup — Poplar Bluff, MO`;
    return (
        <Helmet>
            <title>{fullTitle}</title>
            <meta name="description" content={description} />
            <link rel="canonical" href={canonical} />
            <meta name="robots" content={noindex ? "noindex, nofollow" : "index, follow"} />
            <meta property="og:title" content={fullTitle} />
            <meta property="og:description" content={description} />
            <meta property="og:url" content={canonical} />
            <meta property="og:type" content="website" />
            <meta property="og:image" content={OG_IMAGE} />
            <meta property="og:site_name" content={BUSINESS.name} />
            <meta property="og:locale" content="en_US" />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={fullTitle} />
            <meta name="twitter:description" content={description} />
            <meta name="twitter:image" content={OG_IMAGE} />
            <meta name="geo.region" content="US-MO" />
            <meta name="geo.placename" content="Poplar Bluff" />
            <meta name="geo.position" content="36.757;-90.394" />
            {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
        </Helmet>
    );
};

export const HOME_JSON_LD = localBusinessJsonLd;
